import { render, staticRenderFns } from "./skeletonDetail.vue?vue&type=template&id=0dd2d500&scoped=true"
var script = {}
import style0 from "./skeletonDetail.vue?vue&type=style&index=0&id=0dd2d500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd2d500",
  null
  
)

export default component.exports